import { render, staticRenderFns } from "./ImportDuLieu.vue?vue&type=template&id=45af4406&"
import script from "./ImportDuLieu.vue?vue&type=script&lang=js&"
export * from "./ImportDuLieu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports